import React from 'react';
import PropTypes from 'prop-types';

import { ProgressBar } from 'react-bootstrap-5';

export const baseProgress = 20;
export const zippingProgress = 80;

const FileArchiverProgress = ({ preparedRecordCount, recordCount }) => {
  let label, progress;
  if (recordCount == null) {
    label = 'Preparing files';
    progress = baseProgress;
  } else if (preparedRecordCount < recordCount) {
    label = `Prepared ${preparedRecordCount} of ${recordCount} files`;
    progress = baseProgress + preparedRecordCount / recordCount * (zippingProgress - baseProgress);
  } else {
    label = `Zipping ${recordCount} files`;
    progress = zippingProgress;
  }

  return (
    <div>
      {label}
      <ProgressBar now={progress} />
    </div>
  );
};

FileArchiverProgress.propTypes = {
  preparedRecordCount: PropTypes.number,
  recordCount: PropTypes.number
};

export default FileArchiverProgress;
